module.exports = __webpack_public_path__ + "static/img/M-3.7a03165.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/myixuekao/M-3.png
// module id = e9L9
// module chunks = 0